export const CHAT_MSG_NEW = 0
export const CHAT_MSG_ARRIVAL = 10
export const CHAT_MSG_NOT_ARRIVAL = 11
export const CHAT_MSG_READ = 20

export const CHAT_PRIVATE = 1
export const CHAT_GROUP = 2

export const CHAT_MEMBER_ROLE_NORMAL = 1
export const CHAT_MEMBER_ROLE_ADMIN = 2
export const CHAT_MEMBER_ROLE_CREATOR = 3
